module.exports = __webpack_public_path__ + "img/BUMPER-IMAGE-WIDE.d586a026.jpg";